import { PageComponent } from '../components/page/page.component';
import { Panel } from './panel';
import { DynamicForm } from './dynamic-form';
import { Controls } from '../helpers';
import { FormEngineComponent } from '../typing/form-engine-component';
import { DynamicComponent, PageSchema, PanelSchema } from '../abstractions';
import { ElementManager } from './element-manager';

export class Page
  extends ElementManager<Panel, DynamicForm, PageSchema>
  implements DynamicComponent<PageComponent>
{
  component!: FormEngineComponent<PageComponent>;
  type: Controls;

  constructor(schema: PageSchema, parent: DynamicForm) {
    super(schema, parent);
    this.type = Controls.Page;
  }

  addSchemaElement(panel: PanelSchema): void {
    const newPanel = new Panel(panel, this);
    const previousNode: Panel | null =
      this.elements.length > 1 ? this.elements[this.elements.length - 1] : null;
    if (previousNode) {
      newPanel.setPrevious(previousNode);
    }
    this.elements.push(newPanel);
    this.component.instance.factory.generateView(newPanel);
  }
}
